// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3k-1";
export var rateTableServiceLevelDropdown = "_3k-3";
export var rateTableTypeDropdown = "_3k-0";
export var rateTableValueModeDropdown = "_3k-2";